module.exports = __webpack_public_path__ + "img/2_list3.04cea985.png";